module.exports = __webpack_public_path__ + "static/media/House+.c3524833.png";